module.exports = __webpack_public_path__ + "57113e6e990007945a8dc6227f92bb75.svg";